"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const styled_1 = require("./styled");
const H3_1 = __importDefault(require("../H3"));
const Cross_1 = __importDefault(require("../Icons/Cross"));
class Modal extends react_1.Component {
    constructor(props) {
        super(props);
        this.contentRef = react_1.default.createRef();
        this.state = {
            show: false,
            hidden: false,
        };
        this.open = this.open.bind(this);
        this.close = this.close.bind(this);
    }
    componentDidUpdate(prevProps) {
        var _a, _b, _c, _d;
        const { autoscroll } = this.props;
        const { autoscroll: prevAutoscroll } = prevProps;
        const scrollToTop = (element) => {
            if (!element)
                return;
            if (element.scrollTop) {
                element.scrollTo({ top: 0, behavior: 'smooth' });
            }
            else if (element.children.length > 0) {
                scrollToTop(element.children[0]);
            }
        };
        if (autoscroll && autoscroll !== prevAutoscroll) {
            (_b = (_a = this.contentRef) === null || _a === void 0 ? void 0 : _a.current) === null || _b === void 0 ? void 0 : _b.scrollTo({ top: 0, behavior: 'smooth' });
            if ((_d = (_c = this.contentRef) === null || _c === void 0 ? void 0 : _c.current) === null || _d === void 0 ? void 0 : _d.children) {
                scrollToTop(this.contentRef.current);
            }
        }
    }
    open() {
        const { callback } = this.props;
        this.setState({ show: true, hidden: false });
        if (typeof callback === 'function')
            callback({ action: 'open' });
    }
    close() {
        const { callback, setFilterValue } = this.props;
        this.setState({ show: false });
        if (typeof callback === 'function')
            callback({ action: 'close' });
        if (typeof setFilterValue === 'function')
            setFilterValue('');
    }
    render() {
        const { maxWidth = '500px', contentHeight, preventClose = false, lockScroll = true, title, subheader, filter, footer, children, zIndex, noBorder = false, noPadding = false, } = this.props;
        const { show, hidden } = this.state;
        const viewportHeight = typeof window !== 'undefined' ? window.innerHeight : 100;
        if (!show)
            return react_1.default.createElement(react_1.default.Fragment, null);
        return (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(styled_1.LockScroll, { locked: lockScroll }),
            react_1.default.createElement(styled_1.Overlay, { hidden: hidden, zIndex: zIndex, id: "outer", onMouseDown: (e) => {
                    const target = e.target;
                    if (!preventClose && target.id === 'outer')
                        this.close();
                } },
                react_1.default.createElement(styled_1.Inner, { id: "inner", maxWidth: maxWidth, contentHeight: contentHeight || 'unset', vh: viewportHeight, onMouseDown: (e) => {
                        e.stopPropagation();
                    } },
                    react_1.default.createElement(styled_1.Header, { noHeader: !title && !subheader && !filter },
                        react_1.default.createElement(H3_1.default, null, title && title),
                        !preventClose && (react_1.default.createElement(styled_1.CloseArea, { id: "closer" },
                            react_1.default.createElement("span", { onClick: () => {
                                    this.close();
                                } },
                                react_1.default.createElement(Cross_1.default, { size: 16 })))),
                        subheader && (react_1.default.createElement(react_1.default.Fragment, null,
                            react_1.default.createElement("div", null, subheader),
                            react_1.default.createElement(styled_1.Separator, { noBorder: noBorder }))),
                        filter && react_1.default.createElement("div", null, filter),
                        !subheader && (!!title || !!filter) && (react_1.default.createElement(styled_1.Separator, { noBorder: noBorder }))),
                    react_1.default.createElement(styled_1.Content, { noPadding: noPadding, ref: this.contentRef }, children),
                    !!footer && react_1.default.createElement(styled_1.Footer, { noBorder: noBorder }, footer)))));
    }
}
exports.default = Modal;
//# sourceMappingURL=Modal.js.map